import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IEntubaPricingRequest } from "../interface/entuba/pricing/IEntubaPricingRequest";
import { IReprocessEntubaRequest } from "../interface/entuba/IReprocessEntubaRequest";
import { IEntubaPricingResponse } from "../interface/entuba/pricing/IEntubaPricingResponse";
import { IEntubaPricingDetailResponse } from "../interface/entuba/pricing/IEntubaPricingDetailResponse";

enum EntubaPricingServiceEnum {
  getAll = "/",
  getDetail = "",
  start = "/start",
  reprocess = "/reprocess",
}

export default class EntubaPricingService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/entuba/pricing");
  }

  public getAll = async (): Promise<IEntubaPricingResponse[]> => await this.GET(EntubaPricingServiceEnum.getAll);
  public getDetail = async (id: number): Promise<IEntubaPricingDetailResponse> => await this.GET(`${EntubaPricingServiceEnum.getDetail}/${id}`);
  public startEntubaPricing = async (data: IEntubaPricingRequest) => await this.PUT(EntubaPricingServiceEnum.start, data);
  public reprocessEntubaPricing = async (data: IReprocessEntubaRequest) => await this.PUT(EntubaPricingServiceEnum.reprocess, data);
}
